export default class ContactPage {
	init() {

	}
}